/** Angular Imports */
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

/** rxjs Imports */
import { Observable, of } from 'rxjs';

import { HomeService } from '../home.service';
import { catchError } from 'rxjs/operators';
/**
 * Teller data
 */
@Injectable({
    providedIn: 'root'
})
export class CurrenciesResolver implements Resolve<Object> {


  constructor(
    private homeService: HomeService) {}

  /**
   * Returns list of currencies supported in fineract service
   * @returns {Observable<any>}
   */
  resolve(route: ActivatedRouteSnapshot): Observable<any> {

    return this.homeService.getCurrencies().pipe(
        catchError(error => {
            console.error(`Cant resolve currencies supported`);
            return of([false]);
        })
      );
  }
}
